<template>
  <div>
    <button
      type="button"
      class="btn btn-sm btn-secondary"
      @click="showModalAddDetail"
      v-if="current.estado == 'A'"
    >
      <i class="fa fa-plus"></i>
      Agregar pago
    </button>
    <div
      class="onboarding-modal modal fade"
      id="modalAddDetailReqCompra"
      role="dialog"
      tabindex="-1"
      style="display: padding-right: 15px"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span class="close-label">Salir</span
            ><span class="os-icon os-icon-close"></span>
          </button>
          <div>
            <div class="onboarding-content">
              <div></div>
              <div class="col-12">
                <div class="row">
                  <div
                    style="overflow-y: scroll; max-height: 300px"
                    class="col-6"
                  >
                    <!-------------------- Tabla de REsultados -------------------->
                    <table
                      class="table table-voice table-fixed table-condensed table-hover"
                    >
                      <thead>
                        <tr>
                          <th>
                            <h6 class="text-success text-center">
                              Forma de pago
                            </h6>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="current in formas_pagos"
                          v-bind:key="current.id"
                        >
                          <td
                            class="text-center"
                            v-bind:class="{
                              'bg-success': current.id == form_pago,
                              'bg-white': form_pago == null,
                            }"
                            @click="select(current)"
                          >
                            {{ current.nombre }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-6">
                    <h5 class="text-success text-center">Agregar Pago</h5>
                    <h5
                      v-if="form_pago == 'NC' || form_pago == 'CERT'"
                      class="badge-warning text-danger text-center"
                    >
                      Forma de pago no valida
                    </h5>
                    <div
                      v-if="
                        form_pago && form_pago != 'NC' && form_pago != 'CERT'
                      "
                      class="col-12"
                    >
                      <label>Total Pago</label>
                      <input
                        type="text"
                        v-model="currentPago.total"
                        class="form-control text-center"
                      />
                    </div>

                    <div
                      v-if="
                        form_pago == 'CHEQUE' ||
                        form_pago == 'TARJETA_CREDITO' ||
                        form_pago == 'DEPOSITO'
                      "
                      class="col-12"
                    >
                      <br />
                      <label>Fecha de Vencimiento</label>
                      <input
                        type="date"
                        v-model="currentPago.fecha_vence"
                        class="form-control form-control-sm"
                      />
                    </div>
                    <div
                      v-if="form_pago == 'CHEQUE' || form_pago == 'DEPOSITO'"
                      class="col-12"
                    >
                      <br />
                      <label>Banco</label>
                      <input
                        type="text"
                        v-model="currentPago.banco_referencia"
                        class="form-control form-control-sm text-center"
                      />
                    </div>
                    <div v-if="form_pago == 'DEPOSITO'" class="col-12">
                      <br />
                      <label>No. Boleta</label>
                      <input
                        type="text"
                        v-model="currentPago.numero_cheque"
                        class="form-control form-control-sm text-center"
                      />
                    </div>
                    <div v-if="form_pago == 'CHEQUE'" class="col-12">
                      <br />
                      <label>No. Cheque</label>
                      <input
                        type="text"
                        v-model="currentPago.numero_cheque"
                        class="form-control form-control-sm text-center"
                      />
                    </div>
                    <div v-if="form_pago == 'CHEQUE'" class="col-12">
                      <br />
                      <label>No. Cuenta</label>
                      <input
                        type="text"
                        v-model="currentPago.cuenta_cheque"
                        class="form-control form-control-sm text-center"
                      />
                    </div>
                    <div v-if="form_pago == 'TARJETA_CREDITO'" class="col-12">
                      <br />
                      <label>No. Tarjeta</label>
                      <input
                        type="text"
                        v-model="currentPago.no_tarjeta"
                        class="form-control form-control-sm text-center"
                      />
                    </div>
                    <div v-if="form_pago == 'TARJETA_CREDITO'" class="col-12">
                      <br />
                      <label>Emisor de Tarjeta</label>
                      <select
                        class="form-control"
                        v-model="currentPago.emisor_tarjeta"
                        @change="selectTarjeta(currentPago)"
                      >
                        <option value="VISA">VISA</option>
                        <option value="MASTERCARD">MASTERCARD</option>
                        <option value="AMERICAN EXPRESS">
                          AMERICAN EXPRESS
                        </option>
                        <option value="DINNERS CLUB">DINNERS CLUB</option>
                        <option value="OTRO">OTRO</option>
                      </select>
                    </div>
                    <div
                      v-if="
                        form_pago == 'TARJETA_CREDITO' &&
                        emisor_tarjeta == 'OTRO'
                      "
                      class="col-12"
                    >
                      <br />
                      <label>¿Especifique?</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="currentPago.emisor_tarjeta"
                      />
                    </div>
                    <div v-if="form_pago == 'TARJETA_CREDITO'" class="col-12">
                      <br />
                      <label>No. Autorización</label>
                      <input
                        type="text"
                        v-model="currentPago.autorizacion"
                        class="form-control form-control-sm text-center"
                      />
                    </div>
                  </div>
                  &nbsp;
                  <button
                    class="btn btn-block btn-md btn-success"
                    type="button"
                    @click="agregarPago(current)"
                  >
                    Pagar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {},
  data() {
    return {
      currentPago: {},
      form_pago: null,
      formas_pagos: {},
      emisor_tarjeta: ""
    };
  },
  props: ["current"],
  mounted() {},
  methods: {
    selectTarjeta(currentPago) {
      let self = this;
      self.emisor_tarjeta = currentPago.emisor_tarjeta;
    },
    refreshDefault() {
      let self = this;
      (self.form_pago = ""),
        (self.currentPago = {
          total: "",
          fecha_vence: "",
          banco_referencia: "",
          numero_cheque: "",
          cuenta_cheque: "",
          no_tarjeta: "",
          emisor_tarjeta: "",
          autorizacion: "",
          forma_pago: "",
        });
    },
    showModalAddDetail() {
      let self = this;
      DynamicService.fetch("cat", "forma-pago").then((response) => {
        self.formas_pagos = response.data.results;
        $("#modalAddDetailReqCompra").modal();
      });
    },
    agregarPago(current) {
      let self = this;
      self.currentPago.forma_pago = self.form_pago;
      DynamicService.postAction(
        "cxc",
        "cobros",
        current.id,
        "agregar_pago",
        self.currentPago
      ).then((response) => {
        {
          Notifications.alert.success(
            "Agregar Pago",
            "¡se ha realizado exitosamente!"
          );
          $("#modalAddDetailReqCompra").modal("hide");
          self.refreshDefault();
          self.$emit("refreshData");
        }
      });
    },
    select(current) {
      let self = this;
      self.refreshDefault();
      if (self.form_pago == current.id) {
        self.form_pago = null;
        return;
      }
      self.form_pago = current.id;
    },
  },
};
</script>
